export const routes = {
	connected: '/connected',
	link: '/link',
	welcome: '/welcome',
	error: {
		path: '/error',
		unhandled: '/error/unhandled',
		invalidSession: '/error/invalid-session',
		invalidDevice: '/error/invalid-device'
	},
};
